import ReactDOM from 'react-dom'
import './styles/essential.css'
import './styles/hbtw.css'
import './styles/global/helpers.css'
import App from './pages/App'
import { Provider } from 'react-redux'
import store from './redux/store'
import 'primereact/resources/themes/saga-green/theme.css'
import 'primereact/resources/primereact.min.css'
import 'primeicons/primeicons.css'

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
)
